import React, { useEffect, useState } from 'react'
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Paper, Divider, Stack, CircularProgress, Tooltip } from "@mui/material";
import axios from "../../../utils/fvAxios";
import ButtonV1 from "../../../toolkit/ButtonV1";
import Upload from "../../../icons/Upload";
import InfoIcon from "../../../icons/informationIcon.svg";

function SubscriptionFeeHistory({ SubscriptionInfo }) {
    const SubscriptionHistory = SubscriptionInfo?.length > 0 ? SubscriptionInfo : null;

    const [fileContent, setFileContent] = useState({});
    const [loadingRowId, setLoadingRowId] = useState(null);

    const handleReceiptDownload = (data, index) => {
        setLoadingRowId(index);
        axios.get("Prequalification/DownloadSubscriptionFeePaymentReceipt?vendorMembershipPaymentId=" + data?.vendorMembershipPaymentId +
            "&vendorMembershipSpecificPeriodPaymentsId=" + data?.vendorMembershipSpecificPeriodPaymentsId + "&vendorId=" + data?.vendorId, {
            responseType: "blob",
        }).then((res) => {
            if (res?.data) {
                if (res?.data instanceof Blob) {
                    const file = new Blob([res?.data], { type: "application/pdf" });
                    const fileURL = URL?.createObjectURL(file);
                    const pdfWindow = window?.open();
                    pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');
                    setLoadingRowId(null);
                } else {
                    console.error("Unexpected response format");
                }
            }
            setFileContent(res);
        }).catch((err) => {
            setLoadingRowId(null);
            console.error(err);
        }).finally(() => {
            setLoadingRowId(null);
        });
    };
    return (
        <div>
            <Box
                border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec"
                className="mt-2"
                sx={{ background: "#fff", marginBottom: "10px" }}>
                <Stack spacing={2} direction="row">
                    <h2 className='mx-1' style={{ padding: "10px", marginTop: "12px", float: "left" }}>
                        Subscription Fee Payments
                    </h2>
                </Stack>
                <Divider sx={{ backgroundColor: "#667085", height: "2px" }} />
                <TableContainer component={Paper}>
                    <p style={{ fontSize: "15px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px", textAlign: "center" }} hidden={SubscriptionHistory != null}>
                        No Subscription Fee Payments
                    </p>
                    <Table sx={{
                        minWidth: 1000, minWidth: 1000,
                        borderCollapse: "collapse"
                    }} aria-label="simple table" hidden={SubscriptionHistory == null}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Transaction ID</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Received Date</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Amount </TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }} align="right">Receipt </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {SubscriptionHistory?.map((row, i) => (
                                <TableRow
                                    key={i}
                                    sx={{
                                        "& td, & th": {
                                            borderBottom: "1px solid #E0E0E0"
                                        },
                                        "&:last-child td, &:last-child th": {
                                            borderBottom: "1px solid #E0E0E0" // keep last row visible too
                                        }
                                    }}
                                >
                                    <TableCell style={{ fontSize: "13px" }}>{row?.paymentTransactionId}</TableCell>
                                    <TableCell style={{ fontSize: "13px" }}>{GetfVDateFormate("", row?.paymentReceivedDate)}</TableCell>
                                    <TableCell style={{ fontSize: "13px" }}>${row?.paymentReceivedAmount}</TableCell>

                                    <TableCell style={{ fontSize: "13px" }} align="right">
                                        <ButtonV1
                                            className="border-0"
                                            role="tertiary"
                                            variant="outlined"
                                            id="menu_btn"
                                            style={{
                                                height: "36px",
                                                color: "var(--blue50)",
                                            }}
                                            trailingComponent={
                                                loadingRowId === i ? (
                                                    <CircularProgress size={20} />
                                                ) : (
                                                    <Upload stroke="var(--blue50)" />
                                                )
                                            }
                                            onClick={() => handleReceiptDownload(row, i)}
                                        />
                                        {/* <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                                minHeight: "36px" 
                                            }}
                                        >
                                            {!row?.paymentTransactionId ? (
                                                <Tooltip
                                                    title="This is a skipped payment. Receipt is not available."
                                                    placement="top"
                                                >
                                                    <span
                                                        style={{
                                                            width: "36px",
                                                            height: "36px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <img
                                                            src={InfoIcon}
                                                            alt="Info"
                                                            style={{
                                                                width: "16px",
                                                                height: "16px"
                                                            }}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            ) : (
                                                
                                            )}
                                        </div> */}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </div >
    )
}

export default SubscriptionFeeHistory